import { createContext } from 'react';

import { GapPolicy } from '../types/timeseries-props.js';

export const TimeseriesGapPolicyContext = createContext<GapPolicy>('gap');

TimeseriesGapPolicyContext['displayName'] = 'TimeseriesGapPolicyContext';
